import { ProFormaSecurityModel } from 'api';
import { ReducerAction, ReducerState } from 'common/types/reducers';

/**
 * @function
 * @name setCaptableInfo
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const setCaptableInfo = (
  state: ReducerState,
  action: ReducerAction<{ captableInfo: Partial<ProFormaSecurityModel> }>
) => ({
  ...state,
  ...action,
});

export const getCapTableInfo = (state: ReducerState, action: ReducerAction<{ capTableId: number }>) => ({
  ...state,
  ...action,
});

export const createCapTableProforma = (state: ReducerState, action: ReducerAction<any>) => ({
  ...state,
  ...action,
});
